import React from "react";

export const Footer: React.FC = () => {
  return <footer>© 2020 Jesse Marek -- All Rights Reserved</footer>;
};
